/*------------------------------------*\
    MODULES
\*------------------------------------*/
import Flickity from "flickity";

/*------------------------------------*\
    CAROUSEL
\*------------------------------------*/
class Carousel {
    constructor(passedElement) {
        let self = this;

        self.elem = passedElement;
        self.cells = self.elem.querySelector('[data-carousel-cells]');
        self.thumbs = self.elem.querySelectorAll('[data-carousel-nav-btn]');
    }

    init() {
        let self = this;

        // Init carousel
        const flkty = new Flickity(self.cells, {
            autoPlay: 5000,
            cellAlign: 'left',
            pageDots: false,
            wrapAround: true,
            arrowShape: 'M65.04,100L15.04 50 65.04 0 70.61 5.56 26.17 50 70.61 94.44 65.04 100z'
        });

        // Thumbs
        [...self.thumbs].map(thumb => {

            // Get the index of the carousel slide to which this thumb relates
            let index = parseInt(thumb.getAttribute('data-carousel-nav-btn')) - 1;


            // When the thumb is clicked...
            thumb.addEventListener('click', evt => {
                // Select the appropriate slide in the carousel
                flkty.select(index);
            });
        });

        // On change of carousel slide
        flkty.on('select', index => {
            // Update selected thumbnail
            [...self.thumbs].map(thumb => {
                if (thumb.getAttribute('data-carousel-nav-btn') == (index + 1)) {
                    thumb.classList.add('is-active');
                }
                else {
                    thumb.classList.remove('is-active');
                }
            });
        });
    }
}

export default Carousel;
